import * as R from 'ramda'
import { inputTypeMapping } from './enhance'

const inputTypes = R.keys(inputTypeMapping)

export default inputTypes
